import { useQuery } from '@tanstack/react-query'
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import { auditApi } from '../api/client'
import './CloudWatchMetrics.css'

export function CloudWatchMetrics() {
  const q = useQuery({ queryKey: ['cloudwatch-metrics'],
    queryFn: () => auditApi.cloudwatch(), refetchInterval: 60000 })
  if (q.data && q.data.available === false) {
    return (
      <div className="card cw-metrics cw-degraded">
        <h3>CloudWatch metrics</h3>
        <p className="cw-degraded-msg">
          Metrics unavailable in this environment
          {q.data.reason ? ` — ${q.data.reason}` : ''}.
        </p>
        <p className="cw-degraded-sub">
          Live 15-month history appears once deployed against AWS.
        </p>
      </div>
    )
  }
  const metrics = q.data?.metrics ?? {}
  const names = Object.keys(metrics)
  return (
    <div className="card cw-metrics">
      <h3>CloudWatch metrics · ~15mo</h3>
      {q.isLoading && <p className="cw-degraded-sub">Loading…</p>}
      {!q.isLoading && names.length === 0 && (
        <p className="cw-degraded-sub">No metric data yet.</p>
      )}
      {names.map((name) => {
        const m = metrics[name]
        const series = (m.timestamps ?? []).map((t, i) => ({
          t: t.slice(0, 10),
          v: m.values?.[i] ?? 0,
        }))
        return (
          <div key={name} className="cw-metric">
            <div className="cw-metric-name">{name}</div>
            <ResponsiveContainer width="100%" height={120}>
              <LineChart data={series}>
                <XAxis dataKey="t" stroke="var(--fg-subtle)" fontSize={10} />
                <YAxis stroke="var(--fg-subtle)" fontSize={10} />
                <Tooltip />
                <Line type="monotone" dataKey="v"
                      stroke="var(--series-2)" dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )
      })}
    </div>
  )
}
